import React from 'react';
import { PageHeroBreadcrumb } from '../components/layout/PageHeroBreadcrumb';
import { MobileFooterNav } from '../components/layout/MobileFooterNav';
import { MobileInternalHeader } from '../components/layout/MobileInternalHeader';
import { PharmacistConsultation } from '../components/product/PharmacistConsultation';
export function PharmacistConsultationPage() {
  return <main className="flex-grow bg-gray-50 pt-14 md:pt-[var(--header-height-desktop)]" data-id="element-7509" data-mp="ynrmlwliuqbi">
      <div className="fixed inset-x-0 top-0 z-50 md:hidden" data-id="element-7510" data-mp="ypm7xc0pgkg4">
        <MobileInternalHeader title="Ask a Pharmacist" data-id="element-7511" data-mp="tpztiz954y5q" />
      </div>
      <PageHeroBreadcrumb breadcrumbs={[{
      label: 'Home',
      href: '/'
    }, {
      label: 'Pharmacist Consultation'
    }]} title="Pharmacist Consultation" description="Consult a pharmacist directly to answer your inquiries and get help choosing the right product." data-id="element-7512" data-mp="17oz97heoe2pr" />
      <div className="container mx-auto px-4 py-8 pb-24 md:pb-8" data-id="element-7513" data-mp="2f4dngocr5x80">
        <div className="max-w-3xl mx-auto" data-id="element-7514" data-mp="1hi5nk4doa4q1">
          <PharmacistConsultation data-id="element-7515" data-mp="1mhiasq8ghdt5" />
        </div>
      </div>
      <MobileFooterNav data-id="element-7516" data-mp="1mfxg90m55uva" />
    </main>;
}